"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/focusable.ts
var _focusable = require('@ariakit/react-core/focusable/focusable');



exports.Focusable = _focusable.Focusable;
